import styled from 'styled-components';

import GoogleCloudFilePreview from 'components/GoogleCloudFilePreview';

export const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  row-gap: 10px;
  position: relative;
  margin: 10px;
  width: 140px;
`;

export const Preview = styled(GoogleCloudFilePreview)`
  cursor: pointer;
`;

export const ButtonWrap = styled.div`
  display: flex;
`;

export const SmallBtn = styled.button`
  display: block;
  width: 22px;
  height: 22px;
  background-color: var(--color-greyEC);
  border: 1px solid var(--color-greyF8);
  border-radius: 50%;
  margin-right: 5px;
  outline: none;
  cursor: pointer;
  &:hover {
    background: var(--color-greyEC);
    border: 1px solid var(--color-greyEC);
  }
  &:focus {
    box-shadow: var(--shadow-focus);
  }
  &:active {
    background: var(--color-white);
    border: 1px solid var(--color-grey6A);
  }
`;

export const DeleteBtn = styled(SmallBtn)`
  margin-left: auto;
  margin-right: 0;
`;

export const Label = styled.p`
  font-size: var(--font-size13);
  border-radius: var(--border-radius8);
  color: var(--color-grey6A);
  background-color: var(--color-greyEC);
  padding: 0 4px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

export const IconWrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 22px;
  height: 22px;
`;
